function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

export function supportsFCM() {
    return "serviceWorker" in navigator &&
        "PushManager" in window &&
        !isIOS();
}